import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import { DateTime } from 'luxon'

import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import EventNoteOutlinedIcon from 'components/material-symbol/icons/EventNote'
import SectionEmptyState from 'components/section-empty-state'

import { GetMyLessons } from './query'
import { LaterSessionCard } from './session-card'
import SessionDetailModal from './session-detail'
import SessionSectionHeader from './session-section-header'
import { flattenUpcomingLessons, parseLessons } from './utils'
import { useStyles } from './styles'

const sortPastLessons = lessons =>
  flattenUpcomingLessons(lessons).sort(
    (left, right) =>
      new Date(right.startDateTime).getTime() -
      new Date(left.startDateTime).getTime(),
  )

const PastLessons = ({ lessons, refetchLessons, embedded = false }) => {
  const [openLesson, setOpenLesson] = useState({})
  const classes = useStyles()
  const pastLessons = sortPastLessons(lessons)

  return (
    <>
      {!embedded ? <SessionSectionHeader title="Past sessions" /> : null}
      {pastLessons.length ? (
        <Box className={classes.sessionList}>
          {pastLessons.map(lesson => (
            <LaterSessionCard
              key={lesson.id}
              lesson={lesson}
              onOpenLesson={setOpenLesson}
            />
          ))}
        </Box>
      ) : (
        <Box className={classes.emptyStateContent}>
          <SectionEmptyState
            Icon={EventNoteOutlinedIcon}
            title="No past sessions"
            caption="Your completed lessons will appear here."
            bordered={false}
            compact
          />
        </Box>
      )}
      <SessionDetailModal
        openLesson={openLesson}
        setOpenLesson={setOpenLesson}
        refetchLessons={refetchLessons}
      />
    </>
  )
}

export default ({ studentId, embedded = false }) => {
  const { data, loading, error, refetch } = useQuery(GetMyLessons, {
    variables: {
      studentId,
      orderBy: {
        field: 'START_DATE_TIME',
        direction: 'DESC',
      },
      startDateTime: {
        to: DateTime.local()
          .startOf('minute')
          .toISO(),
      },
    },
  })
  if (loading && !data) return <LinearProgress color="secondary" />
  if (error) return <Box>ERROR</Box>

  const lessons = get(data, 'currentUser.lessons')
  const parsedLessons = parseLessons(lessons, studentId)

  return (
    <PastLessons
      lessons={parsedLessons}
      refetchLessons={refetch}
      embedded={embedded}
    />
  )
}
